import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Camera, X } from "lucide-react";

/**
 * Polls /drop/notifications every 45s. Shows unread photographer drops as a
 * dismissable banner. Clicking "Open" takes admin to Studio for that video
 * AND marks that one as seen.
 */
export default function DropNotificationBanner() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const r = await api.get("/drop/notifications");
      setItems(r.data.notifications || []);
    } catch {
      // silent — not critical
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 45000);
    return () => clearInterval(t);
  }, []);

  const dismissAll = async () => {
    setItems([]);
    try {
      await api.post("/drop/notifications/ack");
    } catch {
      // silent
    }
  };

  const openOne = async (video_id) => {
    setItems((prev) => prev.filter((x) => x.id !== video_id));
    try {
      await api.post(`/drop/notifications/${video_id}/ack`);
    } catch {
      // silent
    }
  };

  if (items.length === 0) return null;
  const n = items.length;
  const first = items[0];
  const label = first.photographer_name || "Anonymous";
  const evt = first.event_name || first.original_name || "New footage";

  return (
    <div
      className="bg-orange-950/60 border-b border-orange-800 px-4 py-2.5 flex items-center gap-3 text-sm"
      data-testid="drop-notification-banner"
    >
      <Camera size={16} className="text-orange-400 shrink-0" />
      <div className="flex-1 min-w-0 truncate">
        <span className="text-orange-300 font-medium">
          {n === 1
            ? `New drop from ${label} — ${evt}`
            : `${n} photographer drops waiting`}
        </span>
      </div>
      {n === 1 && first.id && (
        <Link
          to={`/studio/${first.id}`}
          onClick={() => openOne(first.id)}
          className="btn-secondary !py-1 !px-2 text-[10px] !border-orange-700 !text-orange-300 hover:!bg-orange-600/20"
          data-testid="drop-banner-open"
        >
          Open in Studio
        </Link>
      )}
      {n > 1 && (
        <Link
          to="/studio"
          onClick={dismissAll}
          className="btn-secondary !py-1 !px-2 text-[10px] !border-orange-700 !text-orange-300 hover:!bg-orange-600/20"
          data-testid="drop-banner-view-all"
        >
          Open Studio
        </Link>
      )}
      <button
        onClick={dismissAll}
        className="text-orange-400 hover:text-orange-200 shrink-0"
        title="Dismiss all"
        data-testid="drop-banner-dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
}
